import React, { useEffect, useState } from "react";
import { supabase } from "../lib/supabaseClient";
import Layout from "../components/Layout";
import { PageHeader, Btn, Modal, Field, Input, EmptyState } from "../components/UI";
import { Plus, Pencil, Power } from "lucide-react";

export default function Companies() {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);
  const [edit, setEdit] = useState(null);
  const [form, setForm] = useState({name:"",gstin:"",email:"",phone:"",address:"",is_active:true});
  const [err, setErr] = useState("");

  const load = async () => {
    const { data, error } = await supabase.from("companies").select("*").order("created_at", { ascending: false });
    if (error) { setErr(error.message); return; }
    setItems(data || []);
  };
  useEffect(() => { load(); }, []);

  const openCreate = () => { setEdit(null); setForm({name:"",gstin:"",email:"",phone:"",address:"",is_active:true}); setErr(""); setOpen(true); };
  const openEdit = (it) => { setEdit(it); setForm(it); setErr(""); setOpen(true); };

  const save = async (e) => {
    e.preventDefault();
    setErr("");
    const payload = { ...form };
    delete payload.id; delete payload.created_at; delete payload.updated_at;
    if (edit) {
      const { error } = await supabase.from("companies").update(payload).eq("id", edit.id);
      if (error) { setErr(error.message); return; }
    } else {
      const { error } = await supabase.from("companies").insert(payload);
      if (error) { setErr(error.message); return; }
    }
    setOpen(false); load();
  };

  const deactivate = async (id) => {
    if (!window.confirm("Deactivate this company?")) return;
    const { error } = await supabase.from("companies").update({ is_active: false }).eq("id", id);
    if (error) { alert(error.message); return; }
    load();
  };

  return (
    <Layout>
      <PageHeader title="Companies" subtitle="Tenant companies on the platform"
        actions={<Btn onClick={openCreate} data-testid="company-add"><Plus size={16} className="inline -mt-0.5 mr-1"/>New Company</Btn>}/>
      {err && <div className="text-sm text-red-600 mb-3">{err}</div>}
      {items.length === 0 ? <EmptyState title="No companies"/> : (
        <div className="lt-card overflow-hidden">
          <table className="w-full text-sm">
            <thead className="bg-slate-50 text-xs uppercase text-slate-600">
              <tr><th className="text-left px-4 py-2.5">Name</th><th className="text-left">GSTIN</th><th className="text-left">Email</th><th className="text-left">Phone</th><th className="text-left">Status</th><th className="text-right px-4">Actions</th></tr>
            </thead>
            <tbody>
              {items.map(it => (
                <tr key={it.id} className="border-t hover:bg-slate-50">
                  <td className="px-4 py-2.5 font-medium">{it.name}</td>
                  <td className="text-slate-600">{it.gstin}</td>
                  <td className="text-slate-600">{it.email}</td>
                  <td className="text-slate-600">{it.phone}</td>
                  <td>{it.is_active ? <span className="text-emerald-600 text-xs font-medium">Active</span> : <span className="text-red-600 text-xs">Inactive</span>}</td>
                  <td className="px-4 py-2.5 text-right">
                    <button onClick={()=>openEdit(it)} className="p-1.5 hover:bg-sky-100 rounded text-sky-700"><Pencil size={15}/></button>
                    <button onClick={()=>deactivate(it.id)} className="p-1.5 hover:bg-red-100 rounded text-red-600 ml-1"><Power size={15}/></button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      <Modal open={open} onClose={()=>setOpen(false)} title={edit ? "Edit Company" : "New Company"} size="lg">
        <form onSubmit={save} className="grid grid-cols-2 gap-4">
          <Field label="Name" className="col-span-2"><Input required value={form.name} onChange={e=>setForm({...form,name:e.target.value})}/></Field>
          <Field label="GSTIN"><Input value={form.gstin} onChange={e=>setForm({...form,gstin:e.target.value})}/></Field>
          <Field label="Email"><Input value={form.email} onChange={e=>setForm({...form,email:e.target.value})}/></Field>
          <Field label="Phone"><Input value={form.phone} onChange={e=>setForm({...form,phone:e.target.value})}/></Field>
          <Field label="Status"><select value={form.is_active?"1":"0"} onChange={e=>setForm({...form,is_active:e.target.value==="1"})} className="w-full px-3 py-2 text-sm border border-slate-200 rounded-md"><option value="1">Active</option><option value="0">Inactive</option></select></Field>
          <Field label="Address" className="col-span-2"><Input value={form.address} onChange={e=>setForm({...form,address:e.target.value})}/></Field>
          {err && <div className="col-span-2 text-sm text-red-600">{err}</div>}
          <div className="col-span-2 flex justify-end gap-2"><Btn variant="ghost" type="button" onClick={()=>setOpen(false)}>Cancel</Btn><Btn type="submit" data-testid="company-save">{edit?"Update":"Create"}</Btn></div>
        </form>
      </Modal>
    </Layout>
  );
}
